import parse, { Element } from 'html-react-parser';

import styles from './_ForgotPasswordRichText.module.css';

type ForgotPasswordRichTextProps = {
	className?: string;
	richText?: string;
	targetHash: string;
	clickHandler: () => void;
};

export function ForgotPasswordRichText(props: ForgotPasswordRichTextProps): JSX.Element {
	const replaceLinkWithButton = (domNode: Element) => {
		return props.targetHash && domNode.attribs && domNode.attribs?.href === props.targetHash ? (
			<div tabIndex={0} role="button" className={`link linkOffset linkHoverWeighted ${styles.link}`} onClick={props.clickHandler}>
				{domNode.children.map((child, index) => child.type === 'text' && <span key={index}>{child.data}</span>)}
			</div>
		) : null;
	};

	return (
		<div className={props.className}>
			{parse(props.richText || '', {
				replace(domNode: Element) {
					return replaceLinkWithButton(domNode);
				},
			})}
		</div>
	);
}
